module.exports = __webpack_public_path__ + "static/media/band-champion-no-txt.6cc13f38.svg";